import React from 'react'
import { Drawer, Box, Typography, IconButton, Button } from '@mui/material'
import { Close } from '@mui/icons-material'
import DataModelSchemaStructure from 'pages/DataModelSchema/components/DataModelSchemaStructure'
import { DataModelSchemaDetail } from 'common/types/kraken-core/DataModelSchema'

export interface DataModelSchemaStructureDrawerProps {
  open: boolean
  onClose: () => void
  dataModel?: DataModelSchemaDetail
  title?: string
}

export default function DataModelSchemaStructureDrawer({
  open,
  onClose,
  dataModel,
  title = 'Data Model Schema Structure',
}: DataModelSchemaStructureDrawerProps) {
  if (!dataModel) {
    return null
  }

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: '70%',
          minWidth: '400px',
          maxWidth: '80vw',
        },
      }}
    >
      <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        {/* Header */}
        <Box
          sx={{
            p: 2,
            borderBottom: 1,
            borderColor: 'divider',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h5">{title}</Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              color: theme => theme.palette.grey[500],
            }}
          >
            <Close />
          </IconButton>
        </Box>

        {/* Description */}
        <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
          <Typography variant="body2" color="text.secondary">
            {dataModel.description}
          </Typography>
        </Box>

        {/* Content */}
        <Box sx={{ flex: 1, overflow: 'hidden', p: 1 }}>
          <Box sx={{ height: '100%', overflow: 'auto' }}>
            <DataModelSchemaStructure
              contentType={dataModel.engine || 'application/json'}
              value={dataModel.structure}
              onChange={() => {}} // Read-only in this context
              modelId={dataModel.id}
              readOnly={true}
            />
          </Box>
        </Box>

        {/* Footer */}
        <Box sx={{ p: 2, borderTop: 1, borderColor: 'divider' }}>
          <Button onClick={onClose} variant="outlined" fullWidth>
            Close
          </Button>
        </Box>
      </Box>
    </Drawer>
  )
}
